import './../../shop/modules/multi_checkout/services.multi-checkout';
import './../../shop/modules/services.seven-eleven';
import onLogError from '../../utils/onLogError';
import { createPromiseFunctionWithDelay } from '../../utils/promise';
import { DESTINATION_TYPES } from './constants/destinationType';
import { PAGE_TYPE } from '../../constants/logger';

app.directive('destinationSectionSevenEleven', [
  'sevenElevenService',
  'multiCheckoutService',
  function (sevenElevenService, multiCheckoutService) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../public/themes/shared/multi_checkout/templates.destination-section.seven-eleven.html'),
      scope: {
        store: '=',
        disabled: '=',
        cartTagIds: '=',
        errorMessage: '=',
        updateDestination: '<',
      },
      link: function (scope) {
        scope.actionUrl = () => sevenElevenService.getEMapUrl();
        scope.callbackUrl = () => sevenElevenService.getEMapCallbackUrl();

        const trackerPromiseWithDelay = createPromiseFunctionWithDelay(() => {
          multiCheckoutService.trackFillRecipientData(
            DESTINATION_TYPES.STORE_MAP_7_11,
          );
        });

        scope.onEMapSubmitClick = (event) => {
          event.preventDefault();
          scope
            .updateDestination()
            .then(() =>
              Promise.all([
                multiCheckoutService.saveSessionData({
                  cart_tag_ids: scope.cartTagIds,
                }),
                trackerPromiseWithDelay(),
              ]),
            )
            .then(() => {
              $('#multi_checkout_seven')[0].submit();
            })
            .catch((error) => {
              onLogError({
                error,
                page: PAGE_TYPE.cart,
                debugMessage: 'unable to open e-map of seven eleven.',
                sourceName: 'destinationSectionSevenEleven#onEMapSubmitClick',
              });
            });
        };
      },
    };
  },
]);
